<template>
  <div class="navigation-link" :class="classes">
    <router-link :to="to"><feather-icon icon="play" :options="options"/></router-link>
  </div>
</template>

<script>
import FeatherIcon from './FeatherIcon.vue'

export default {
  props: ['to','rotation', 'color', 'classes'],
  components: {
    FeatherIcon
  },
  computed: {
    options() {
      return {
        class: 'r'+this.rotation,
        width: 25,
        height: 25
      }
    }
  }
}
</script>

<style>
  .navigation-link {
    opacity: 0.25;
    transition: opacity 0.3s ease;
  }
  
  .navigation-link:hover {
    opacity: 0.25;
  }
  .navigation-link a {
    color: #111;
  }

  .navigation-link svg {
    fill: #fff;
  }

  .navigation-link--next {
    position: fixed;
    right: 10px;
    top: 50%;
  }

  .navigation-link--next__contents {
    position: fixed;
    right: calc(10px + 300px);
    top: 50%;
  }

  .navigation-link--prev {
    position: fixed;
    left: 10px;
    top: 50%;
  }

  .navigation-link--up {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 45px;
  }

  .navigation-link--down {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }

  .right-to-left .navigation-link--next {
    left: 0;
    right: auto;
    transform: rotate(180deg);
  }

  .right-to-left .navigation-link--prev {
    right: 0;
    left: auto;
    transform: rotate(180deg);
  }

  @media (max-width: 992px) {
    .navigation-link {
      opacity: 0.25;
      transition: opacity 0.3s ease;
    }

    .navigation-link--next__contents {
      position: fixed;
      right: 40px;
      top: 50%;
    }

    .navigation-link--prev {
      position: fixed;
      left: 0px;
      top: 50%;
    }

    .navigation-link--next {
      position: fixed;
      right: 28px;
      top: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavigationLink.vue